var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { createContext, useContext, useReducer } from 'react';
var FORM_UPDATE = 'FORM_UPDATE';
var FIELD_INVALID = 'FIELD_INVALID';
var FIELD_VALID = 'FIELD_VALID';
var FormReducer = function (state, action) {
    var _a;
    switch (action.type) {
        case FORM_UPDATE:
            return __assign(__assign({}, state), { values: action.values });
        case FIELD_INVALID:
            var validationMessageHasNotChanged = state.validationMessages.hasOwnProperty(action.field.id) &&
                state.validationMessages[action.field.id].message &&
                state.validationMessages[action.field.id].message ===
                    action.field.message;
            if (state.invalidFields.includes(action.field.id) &&
                validationMessageHasNotChanged) {
                return state;
            }
            var currentInvalidFields = state.invalidFields
                .slice(0)
                .filter(function (item) {
                return item !== action.field.id;
            });
            return __assign(__assign({}, state), { invalidFields: __spreadArrays(currentInvalidFields, [action.field.id]), validationMessages: __assign(__assign({}, state.validationMessages), (_a = {}, _a[action.field.id] = action.field, _a)) });
        case FIELD_VALID:
            var updatedFields = state.invalidFields.slice(0).filter(function (item) {
                return item !== action.field.id;
            });
            var updatedMessages = __assign({}, state.validationMessages);
            if (updatedMessages[action.field.id]) {
                delete updatedMessages[action.field.id];
            }
            return __assign(__assign({}, state), { invalidFields: updatedFields, validationMessages: updatedMessages });
        default:
            return state;
    }
};
export var FormContext = createContext([]);
export var FormProvider = function (_a) {
    var initialState = _a.initialState, children = _a.children;
    return (React.createElement(FormContext.Provider, { value: useReducer(FormReducer, initialState) }, children));
};
export var useFormValue = function () { return useContext(FormContext); };
